import React    from 'react';
import Team     from './Team';
import { Card } from '@rmwc/card';
import '@rmwc/card/styles';
import '@rmwc/typography/styles';
import style    from './style.scss';

export default function ( props ) {
	const { id, winner, ht, vt, final, notes, time, updated, period } = props;

	return (
		<div key={id} className={style.gameCardWrap}>
			<Card id={`game-id-${id}`} className={style.gameCard}>
				<div className={style.teamsWrap}>
					<Team {...{ ...vt, ...('vt' === winner ? { winner : true } : {}) }} />
					<Team {...{ ...ht, ...('ht' === winner ? { winner : true } : {}) }} />
				</div>
				<div className={style.cardFooter}>
					<div className='mdc-typography--caption'>
						{notes && <div>{notes}</div>}
						{`${final ? 'Final' : (period ? `${period}` : `Starts at ${time}`)}. `}
						{period && <span className={style.whitespaceNowrap}>
                            {`At ${(new Date( updated )).toLocaleTimeString( [], {
	                            hour   : '2-digit',
	                            minute : '2-digit',
                            } ).toLowerCase().replace( ' ', '' )}.`}
                        </span>}
					</div>
				</div>
			</Card>
		</div>
	);
}
